import React from "react";
import { TargetIcon } from "assets";

export const TARGETS_PAGE = {
    ABSOLUTE_PATH: "/targets",
    TITLE: "Targets - Setup",
    SIDEBAR_TITLE: "Targets",
    ICON: <TargetIcon />,
    renderMenu: false,
    configParameter: "target_setting_feature",
    hideInSidebarWhenDisabled: true,
};